import Vue from 'vue'
import Router from 'vue-router'
const Login = resolve => require(['@/views/Login'], resolve)
const CustomerDetails = resolve => require(['@/views/CustomerDetails'], resolve)
const PaymentPage = resolve => require(['@/views/PaymentPage'], resolve)
const PastPayments = resolve => require(['@/views/PastPayments'], resolve)
const Contact = resolve => require(['@/views/Contact'], resolve)
const Register = resolve => require(['@/views/Registration'], resolve)
const ResetPassword = resolve => require(['@/views/ResetPassword'], resolve)
const Settlement = resolve => require(['@/views/Settlements'], resolve)

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Register/:id',
      name: 'RegisterWithId',
      component: Register
    },
    {
      path: '/ResetPassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/ResetPassword/:partyId',
      name: 'ResetPasswordWithId',
      component: ResetPassword
    },
    {
      path: '/Index',
      name: 'CustomerDetails',
      component: CustomerDetails,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/MakePayment',
      name: 'MakePayment',
      component: PaymentPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Settlement',
      name: 'Settlement',
      component: Settlement,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/YourDetails',
    //   name: 'FullDetails',
    //   component: FullDetails,
    //   meta:{
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/PaymentHistory',
      name: 'PaymentHistory',
      component: PastPayments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact,
      meta: {
        requiresAuth: true
      }
    },
    { path: "*", component: Login }
  ]
})